import firebase from 'firebase'
import { airtableConfig } from '@/config.js'
const base = airtableConfig.base

export const airtable = {
  actions: {
    createRecords ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const createRecords = firebase.functions().httpsCallable('createRecords')
        // the airtable api can accept up to 10 records for creates in one call
        // take the records from this payload and chunk them into arrays of 10
        function chunkArray(array, chunkSize) {
          let chunkedArrays = []
          for (let index = 0; index < array.length; index += chunkSize) {
            const chunk = array.slice(index, index + chunkSize)
            chunkedArrays.push(chunk)
          }
          return chunkedArrays
        }
        const batchUpdates = chunkArray(payload.records, 10)
        let batchPromises = []
        batchUpdates.forEach(batch => {
          batchPromises.push(createRecords({
            base: base,
            table: payload.table,
            records: batch
          }))
        })
        Promise.all(batchPromises)
          .then(values => {
            if (payload.dispatch) {
              dispatch(payload.dispatch)
            }
            return resolve(values)
          })
          .catch(err => {
            return reject(err)
          })
      })
    },
    deleteRecords ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const deleteRecords = firebase.functions().httpsCallable('deleteRecords')
        // the airtable api can accept up to 10 records for updates in one call
        // take the records from this payload and chunk them into arrays of 10
        function chunkArray(array, chunkSize) {
          let chunkedArrays = []
          for (let index = 0; index < array.length; index += chunkSize) {
            const chunk = array.slice(index, index + chunkSize)
            chunkedArrays.push(chunk)
          }
          return chunkedArrays
        }
        const recordIds = payload.records.map(r => {
          return r.id
        })
        const batchUpdates = chunkArray(recordIds, 10)
        let batchPromises = []
        batchUpdates.forEach(batch => {
          batchPromises.push(deleteRecords({
            base: base,
            table: payload.table,
            recordIds: batch
          }))
        })
        Promise.all(batchPromises)
          .then(values => {
            if (payload.dispatch) {
              dispatch(payload.dispatch)
            }
            return resolve(values)
          })
          .catch(err => {
            return reject(err)
          })
      })
    },
    updateRecords ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const updateRecords = firebase.functions().httpsCallable('updateRecords')
        // the airtable api can accept up to 10 records for updates in one call
        // take the records from this payload and chunk them into arrays of 10
        function chunkArray(array, chunkSize) {
          let chunkedArrays = []
          for (let index = 0; index < array.length; index += chunkSize) {
            const chunk = array.slice(index, index + chunkSize)
            chunkedArrays.push(chunk)
          }
          return chunkedArrays
        }
        const batchUpdates = chunkArray(payload.records, 10)
        let batchPromises = []
        batchUpdates.forEach(batch => {
          batchPromises.push(updateRecords({
            base: base,
            table: payload.table,
            records: batch
          }))
        })
        Promise.all(batchPromises)
          .then(values => {
            if (payload.dispatch) {
              dispatch(payload.dispatch)
            }
            return resolve(values)
          })
          .catch(err => {
            return reject(err)
          })
      })
    },
    getRecords ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const getRecordsFromView = firebase.functions().httpsCallable('getRecordsFromView')
        let options = {
          base: base,
          table: payload.table,
          view: payload.view
        }
        if (payload.filter) {
          options.filter = payload.filter
        }
        if (payload.searchFormula) {
          options.searchFormula = payload.searchFormula
        }
        getRecordsFromView(options)
        .then(result => {
          if (payload.dispatch) {
            dispatch(payload.dispatch, result.data.records)
          }
          return resolve(result.data.records)
        })
        .catch(err => {
          return reject(err)
        })
      })
    }
  }
}
